/**
 * @generated SignedSource<<99b2ac4543f90bc3b832df93c7125948>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "intercomUserIdentity",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useOrderModalsQuery",
    "selections": (v0/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useOrderModalsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "61708f048302259bd9294e4434f26203",
    "id": null,
    "metadata": {},
    "name": "useOrderModalsQuery",
    "operationKind": "query",
    "text": "query useOrderModalsQuery {\n  user {\n    id\n    rowId\n    firstName\n    lastName\n    email\n    intercomUserIdentity\n  }\n}\n"
  }
};
})();

node.hash = "c86ec22d35fa2237ab34b1e6c260fc20";

module.exports = node;
